import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import LineTagAltIcon from 'LuxKit/Icons/line/LineTagAltIcon'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'

interface Props {
  offer: App.CarHireOffer
}
function CarHireDiscountTag(props: Props) {
  const { offer } = props
  const intl = useIntl()

  const discountPercentage = useMemo(() => offer.rateOptions[0]?.payNowDiscountPercentage ?? 0, [offer.rateOptions])

  if (discountPercentage === 0) {
    return null
  }

  return <PromotionLabel icon={<LineTagAltIcon />}>
    {intl.formatMessage(
      {
        id: 'IP8WEulBuCxZy2CyXCCg',
        defaultMessage: '{discountPercentage}% off applied',
        description: 'Discount percentage label on car hire offer tile in the car hire section',
      },
      { discountPercentage },
    )}
  </PromotionLabel>
}

export default CarHireDiscountTag
